const Divider = () => {
    return (
        <div style={{height:'1px', width:'100%', backgroundColor:'#A3A5BA', margin:'5px 0'}} />
    )
}

export default Divider;